import * as R from 'ramda';
import styled from 'styled-components';
import { space, borderColor } from 'styled-system';
// helpers/constants
import * as G from '../../../../helpers';
//////////////////////////////////////////////////

export const IconWrapper = styled.span`
  width: 24px;
`;

export const LgMenuWrapper = styled.div`
  top: 0;
  width: 265px;
  display: flex;
  height: 100dvh;
  position: fixed;
  flex-direction: column;
  transition: left .2s linear;
  border-radius: 0 25px 25px 0;
  justify-content: space-between;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  left: ${({ isMenuOpen }) => G.ifElse(isMenuOpen, '60px', '-265px')};
  background: ${({ bg }) => bg || G.getTheme('colors.light.mainLight')};

  ${({ glassEffect }) =>
    glassEffect &&
    `
      backdrop-filter: blur(5px);
      -webkit-backdrop-filter: blur(5px);
    `
  };
`;

export const BranchDropDownWrapper = styled.div`
  width: 100%;
  height: 94px;
  overflow-y: auto;
  padding: 5px 10px 0;
  color: ${({ color }) => color || G.getTheme('header.textColor')};
  & > div {
    display: flex;
    padding: 4px 0;
    align-items: center;
    &:hover {
      cursor: pointer;
      font-weight: bold;
      color: ${({ color }) => color || G.getTheme('colors.light.darkRed')};
    }
    & svg {
      width: 18px;
      height: 18px;
    }
    & > span:last-child {
      padding: 0 5px;
    }
  }
`;

export const HrDivider = styled.hr`
  ${space}
  ${borderColor}

  opacity: 0.2;
  border-top: '2px solid';
`;

HrDivider.defaultProps = {
  borderColor: 'darkGrey',
};

export const ReleaseVersionText = styled.div`
  ${space}

  &:hover {
    font-weight: ${({ withHover }) => R.and(withHover, 'bold')};
    cursor: ${({ withHover }) => G.ifElse(withHover, 'pointer', 'unset')};
  }
`;

export const ReleaseVersionLink = styled.a`
  ${space}

  color: inherit;
  text-decoration: inherit;

  &:hover {
    font-weight: ${({ withHover }) => R.and(withHover, 'bold')};
    cursor: ${({ withHover }) => G.ifElse(withHover, 'pointer', 'unset')};
  }
`;

export const SidebarGroupWrapper = styled.div`
  overflow: hidden;
  transition: 0.5s;
  max-height: ${({ opened }) => G.ifElse(opened, '1500px', '40px')};
`;

export const SidebarItem = styled.div`
  height: 40px;
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;

  padding: ${({ isSubmenuItem }) => (
    G.ifElse(
      G.isTrue(isSubmenuItem),
      '0 10px 0 20px',
      '0 10px',
    ))
  };

  ${({ color, active, isSubmenuItem }) => (
    R.and(
      active,
      `&:before {
        left: 0;
        content: '';
        height: 100%;
        position: absolute;
        width: ${G.ifElse(isSubmenuItem, 3, 2)}px;
        background-color: ${color || G.getTheme('menus.sidebar.itemTextColor')};
      }`,
    )
  )}

  font-weight: ${({ active }) => R.and(active, 'bold')};

  color: ${({ color }) => color || G.getTheme('menus.sidebar.itemTextColor')};

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

  & > span {
    margin: 5px;
    display: inline-flex;
  }
  &:hover {
    font-weight: bold;
  }
`;

export const TabItem = styled(SidebarItem)`
  padding-left: 65px;

  ${({ color, active }) => (
    R.and(
      active,
      `&:before {
        left: 0;
        width: 5px;
        content: '';
        height: 100%;
        position: absolute;
        background-color: ${color || G.getTheme('menus.sidebar.itemTextColor')};
      }`,
    )
  )}
`;

export const SidebarItemRightPlusIcon = styled.div`
  right: 0;
  top: 30%;
  font-weight: bold;
  margin-right: 12px;
  position: absolute;
`;

export const SidebarItemRightArrowIcon = styled.div`
  right: 0;
  top: 30%;
  margin-right: 10px;
  position: absolute;
`;

export const SidebarSearchInput = styled.input`
  ${space}

  border: none;
  width: 240px;
  height: 32px;
  outline: none;
  background: red;
  padding: 0 10px;
  font-size: 14px;
  margin-top: -5px;
  margin-bottom: 4px;
  color: ${G.getTheme('colors.light.mainLight')};
  background: ${G.getTheme('colors.transparentMask')};
  border-bottom: 1px solid ${({ color }) => color || G.getTheme('colors.light.mainLight')};

  &::placeholder {
    color: ${({ color }) => color || G.getTheme('colors.light.mainLight')};
  }

  &:focus::placeholder {
    color: transparent;
  }
`;

